import DisabledIcon from '../../assets/disabled.png'
import DisabledIconWhite from '../../assets/disabled_white.png'
import Popover, { PopoverOrigin } from '@material-ui/core/Popover'
import { UpgradePremiumPopover } from '../../screens/UpgradePremium/UpgradePremium'
import React from 'react'

type PopoveredIcon2Props = {
  anchorEl?: HTMLElement | null;
  onOpen?: (event: any) => void;
  onClose?: (event: any) => void;
  variant?: 'grey' | 'white' | 'secondary' | string;
  withIcon?: boolean;
  transformOrigin?: PopoverOrigin;
  anchorOrigin?: PopoverOrigin;
  style?: any;
};

export const PopoveredIcon2 = ({ anchorEl, onOpen, onClose, variant='grey', withIcon = true,anchorOrigin, transformOrigin,style }: PopoveredIcon2Props) => {
  const open = Boolean(anchorEl);

  return (
    <>
    {withIcon && <img
        src={variant === 'white' ? DisabledIconWhite : DisabledIcon}
        alt="templates"
        onMouseEnter={onOpen ?? null}
      />}
      <Popover
        style={style}
        disableRestoreFocus
        disableAutoFocus
        disableEnforceFocus
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={anchorOrigin ? anchorOrigin : {
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={transformOrigin}
        onClose={onClose}
        onClick={e => e.stopPropagation()}
      >
        <UpgradePremiumPopover handleClose={onClose} />
      </Popover>
    </>
  );
};
